import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  card: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(4),
    padding: theme.spacing(2),
    width: "100%",
  },
  inputsRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "stretch",
    },
  },
  countrySelect: {
    flex: 1,
    [theme.breakpoints.down("sm")]: {
      flex: "unset",
    },
  },
  dniInput: {
    flex: 3,
    [theme.breakpoints.down("sm")]: {
      flex: "unset",
    },
  },
  submitButton: {
    flex: 1,
    padding: theme.spacing(1),
    fontSize: "1.2rem",

    [theme.breakpoints.down("sm")]: {
      flex: "unset",
    },
  },
  noBorderCard: {
    borderRadius: 0,
    boxShadow: "none",
  },
}));
